import { extendTailwindMerge } from 'tailwind-merge';

export const twm = extendTailwindMerge<string, string>({
  extend: {
    // Ajout des valeurs personnalisées du thème
    theme: {
      // Couleurs personnalisées
      color: [
        'transparent',
        // Foreground colors
        'fg-primary',
        'fg-on-accent',
        'fg-secondary',
        'fg-secondary-hover',
        'fg-tertiary',
        'fg-tertiary-hover',
        'fg-quaternary',
        'fg-quaternary-hover',
        'fg-brand-primary',
        'fg-disabled',
        'fg-error-primary',
        'fg-error-secondary',
        'fg-success-primary',
        'fg-success-secondary',
        // Text colors
        'text-primary',
        'text-on-accent',
        'text-secondary',
        'text-secondary-hover',
        'text-tertiary',
        'text-disabled',
        'text-error',
        'text-success',
        'text-warning',
        // Border colors
        'border-primary',
        'border-secondary',
        'border-accent',
        'border-error',
        'border-error-secondary',
        'border-warning',
        'border-warning-secondary',
        'border-success',
        'border-tertiary',
        // Surface colors
        'surface-background',
        'surface-primary',
        'surface-primary-hover',
        'surface-secondary',
        'surface-secondary-hover',
        'surface-secondary-selected',
        'surface-tertiary',
        'surface-tertiary-hover',
        'surface-disabled',
        'surface-accent',
        'surface-accent-hover',
        'surface-accent-light',
        'surface-brand',
        'surface-error-primary',
        'surface-error-primary-hover',
        'surface-error-secondary',
        'surface-success-primary',
        'surface-success-primary-hover',
        'surface-success-secondary',
        'surface-overlay',
      ],

      // Spacings personnalisés
      spacing: [
        'none',
        'xxs',
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        '2xl',
        '3xl',
        '4xl',
        '5xl',
        '6xl',
        '7xl',
        '8xl',
        '9xl',
        '10xl',
        '11xl',
      ],

      // Poids de police personnalisés
      'font-weight': ['400', '500', '600', '700', '900'],

      // Famille de police personnalisée
      font: ['inter', 'YetGrotesk'],

      // Tailles de texte personnalisées
      text: [
        'display-large',
        'display-medium',
        'display-small',
        'body-xl',
        'body-lg',
        'body-md',
        'body-sm',
        'body-xs',
        'body-xxs',
      ],

      // Hauteurs de ligne personnalisées
      leading: [
        'lh-display-large',
        'lh-display-medium',
        'lh-display-small',
        'lh-body-xl',
        'lh-body-lg',
        'lh-body-md',
        'lh-body-sm',
        'lh-body-xs',
      ],

      // Radius personnalisés
      borderRadius: ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'full'],

      // Ombres personnalisées
      shadow: ['md'],
    },
  },
});
